// JSON client of the server's REST API (server/src/api.ts). Authentication: the HttpOnly session cookie.

export class ApiError extends Error {
  readonly status: number;
  readonly code: string;
  constructor(status: number, code: string, message: string) {
    super(message);
    this.status = status;
    this.code = code;
  }
}

export interface Me {
  id: number;
  login: string;
  isAdmin: boolean;
}

export async function api<T = any>(method: string, path: string, body?: unknown): Promise<T> {
  let res: Response;
  try {
    res = await fetch(path, {
      method,
      credentials: 'same-origin',
      headers: body !== undefined ? { 'content-type': 'application/json' } : {},
      body: body !== undefined ? JSON.stringify(body) : undefined,
    });
  } catch {
    throw new ApiError(0, 'network', 'Нет связи с сервером');
  }
  let json: any = null;
  try {
    json = await res.json();
  } catch {
    /* empty or not JSON */
  }
  if (!res.ok) throw new ApiError(res.status, json?.error ?? 'http_' + res.status, json?.message ?? `Ошибка ${res.status}`);
  return json as T;
}

/** the signed-in user, or null */
export async function getMe(): Promise<Me | null> {
  try {
    return await api<Me>('GET', '/api/me');
  } catch (e) {
    if (e instanceof ApiError && e.status === 401) return null;
    throw e;
  }
}

/** URL of the sign-in page that comes back here afterwards */
export function loginUrl(): string {
  return '/?next=' + encodeURIComponent(location.pathname + location.search);
}
